import React, { FC } from 'react';
import usePortal from 'hooks/usePortal';
import ReactDOM from 'react-dom';

import * as Styled from './styled';
import { BaseModalProps } from './types';

const BaseModal: FC<BaseModalProps> = ({
  children,
  innerRef,
  isOpen = true,
}) => {
  const portal = usePortal('riskMotorFlow');

  if (!portal) return null;

  if (!isOpen) return null;
  return ReactDOM.createPortal(
    <Styled.Container>
      <Styled.Backdrop ref={innerRef} />
      <Styled.Wrapper>
        <Styled.OutsideArea data-testid="basemodal-outsidearea" />
        <Styled.Stage>{children}</Styled.Stage>
      </Styled.Wrapper>
    </Styled.Container>,
    portal
  );
};

export default BaseModal;
